import { ChangeDetectionStrategy, Component, input, output, viewChild } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { Observable } from 'rxjs';
import { DrawerDirective } from '../drawer/drawer.directive';
import { SwitchComponent } from '../switch/switch.component';
import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';

@Component({
	selector: 'skl-columns-toggler',
	template: `
		<ng-template
			sklDrawer
			#columnsDrawer="sklDrawer"
		>
			<header>
				<skl-button
					data-kind="icon-only"
					typeName="transparent"
					(click)="columnsDrawer.close()"
				>
					<skl-icon size="20px" name="arrow-r-right" />
				</skl-button>
				<h2>
					{{ 'scenes.shared.service.columns.manage' | translate }}
				</h2>
			</header>

			<section>
				@for (column of (columnsData() | async) || []; track column.identityName) {
					@if (!gridOptions().disabledToToggle.includes(column.identityName)) {
						<skl-switch
							[label]="column.label || column.header"
							[ngModel]="!column.isHidden"
							(ngModelChange)="onColumnToggle(column, $event)"
						></skl-switch>
					}
				}
			</section>

			<footer>
				<skl-button (click)="onRestore()">
					<skl-icon name="arrow-reset-filled" size="20px"/>{{ 'scenes.shared.service.columns.restore-defaults' | translate }}
				</skl-button>
			</footer>
		</ng-template>
		`,
	imports: [
		FormsModule,
		AsyncPipe,
		TranslatePipe,
		DrawerDirective,
		SwitchComponent,
		ButtonComponent,
		IconComponent
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColumnsTogglerComponent {
	public readonly columnsData = input.required<Observable<any[]>>({ alias: 'columns-data' });
	public readonly gridOptions = input.required<any>({ alias: 'grid-options' });

	public readonly columnToggle = output<{ column: any, isChecked: boolean }>();
	public readonly restore = output<void>();

	protected readonly columnsDrawer = viewChild.required<DrawerDirective>('columnsDrawer');

	public open(): void {
		this.columnsDrawer().open();
	}

	public close(): void {
		this.columnsDrawer().close();
	}

	protected onColumnToggle(column: any, isChecked: boolean): void {
		this.columnToggle.emit({ column, isChecked });
	}

	protected onRestore(): void {
		this.restore.emit();
	}
}